import { ContextService } from '../../../../services/context_service';
import { DataService } from '../../../../services/data_service';
import DialogWrapper2 from '../../../../core/dialog/dialog_wrapper_v2';
import { filterMethodFulltext } from '../../../../core/forms/helpers/filter_method_fulltext';
import formStyle from '../../../../core/forms/style/WForm.less';
import { getFieldKey, setLocaleFieldKeys, toggleI18nFields } from './functions/LocaleFields';
import { IDs } from '../../../../helpers/IDs';
import { i18n } from '../../../../i18n/i18n';
import { i18nLang } from '../../../../i18n/i18nLang';
import { LanguageSelect } from './LanguageSelect';
import { lazyInject } from '../../../../services/inversify';
import parse from 'html-react-parser';
import * as React from 'react';
import { StructureService } from '../../../../services/structure_service';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { WFormsTableWrapper } from '../../../../core/table/WFormsTableWrapper';

// Copyright TinyEditor ausblenden
// .tox-notifications-container
// .tox-statusbar__branding
// src/main/main.css

export interface MehrsprachigkeitGlossarProps {
    admin?: boolean;
    data: any;
    isMultilingual?: boolean;
}

export interface MehrsprachigkeitGlossarState {
    data: any[];
    glossar: any;
    language: string;
    locale: string;
    tabIndex: number;
}

export class MehrsprachigkeitGlossar extends React.Component<MehrsprachigkeitGlossarProps, MehrsprachigkeitGlossarState> {

    constructor(props: any) {
        super(props);
        const languageSelected: string = (props.data || {}).LANGUAGE_SELECTED || i18nLang.getUILang();
        this.state = {
            data: null,
            glossar: null,
            language: languageSelected,
            locale: languageSelected,
            tabIndex: this.contextService.get('tabIdxMehrsprachigkeitGlossar') ? this.contextService.get('tabIdxMehrsprachigkeitGlossar') : 0
        };
        this.getCustomFormConfigFunc = this.getCustomFormConfigFunc.bind(this);
        this.init = this.init.bind(this);
    }

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;

    private customColumns: string[] = ['name', 'info', 'beschreibung'];
    private fieldKeys: any[] = [
        { name: 'name' },
        { name: 'info' },
        { name: 'beschreibung' }
    ];
    private fields: any[] = [];
    private hiddenColumns: string[] = [];
    private showingColumns: string[] = [];

    componentDidMount(): void {
        this.init();
    }

    componentDidUpdate(prevProps: any, prevState: any): void {
        const languageSelected: string = (this.props.data || {}).LANGUAGE_SELECTED || i18nLang.getUILang();

        if (languageSelected !== this.state.locale) {
            this.setState({ data: null, language: languageSelected, locale: languageSelected }, this.init);
        }
    }

    getCustomFormConfigFunc(formConfig: any, formData: any): void {
        toggleI18nFields(formConfig.items, (formData || {}).values, this.state.language);
    }

    getCustomActions(): any[] {
        const anzeigen: string = i18n('Anzeigen', 'sys');

        return [
            {
                id: 'showGlossar',
                label: anzeigen,
                key: 'show',
                func: ((row: any) => this.setState({ glossar: row })),
                info: anzeigen
            }
        ];
    }

    getCustomColumns(): any[] {
        const begriff: string = i18n((this.fields.find((field: any) => field.key === this.fieldKeys[0].locale) || {}).name, 'entity');
        const beschreibung: string = i18n((this.fields.find((field: any) => field.key === this.fieldKeys[2].locale) || {}).name, 'entity');
        const keyBeschreibung = (data: any): string => getFieldKey(data, this.fieldKeys[2]);
        const keyName = (data: any): string => getFieldKey(data, this.fieldKeys[0]);

        return [
            {
                accessor: 'name_table',
                Header: begriff,
                HeaderText: begriff,
                id: 'name_table',
                type: 'text',
                filterMethod: (filter: any, row: any) => filterMethodFulltext(filter, row._original, keyName(row._original))
            },
            {
                accessor: 'beschreibung_table',
                Header: beschreibung,
                HeaderText: beschreibung,
                id: 'beschreibung_table',
                type: 'text',
                filterMethod: (filter: any, row: any) => filterMethodFulltext(filter, row._original, keyBeschreibung(row._original))
            }
        ];
    }

    getExtraFormElements(): any {
        return {
            name:
                <div className={formStyle.fieldBox}>
                    <LanguageSelect
                        label={`${i18n('Sprache', 'sys')}:`}
                        onChange={(language: string) => this.setState({ language })}
                        value={this.state.language}
                    />
                </div>
        };
    }

    getNames(data: any[]): any {
        const names: any = {};

        (data || [])
            .sort((a: any, b: any) => a.tid - b.tid)
            .forEach((item: any) => {
                if (typeof names[item.name] === 'undefined') {
                    names[item.name] = [];
                }
                names[item.name].push(item.tid);
            });

        return names;
    }

    getTabStyle(idx: number): any {
        const tabColor = '#616468';
        const tabColorBorder = '#616468';
        const tabColorFont = 'white';
        const tabColorFontSelected = 'black';
        const tabColorSelected = 'white';

        return {
            backgroundColor: this.state.tabIndex === idx ? tabColorSelected : tabColor,
            borderColor: tabColorBorder,
            borderRadius: 0,
            color: this.state.tabIndex === idx ? tabColorFontSelected : tabColorFont
        };
    }

    init(): any {
        setLocaleFieldKeys(this.fieldKeys, this.state.locale);
        const fields: any[] = (((((StructureService || {}).structures || {})[IDs.MOD_ETOOL_ADMIN] || {})[IDs.ENT_GLOSSAR] || {}).ATTS || [])
            .map((field: any) => ({
                key: field.KEY, ...(field.NAME && { name: field.NAME }), ...(field.HIDDEN && { hidden: field.HIDDEN })
            }));
        toggleI18nFields(fields, null, this.state.language, this.customColumns, (data: any) => {
            data = data || {};
            this.fields = fields;
            this.hiddenColumns = data.hiddenColumns || [];
            this.showingColumns = data.showingColumns || [];
        });
        this.loadData();
    }

    loadData(): void {
        const tabIndex: any = !this.props.admin ? { tabIndex: 0 } : {};
        this.dataService.loadData(
            IDs.ENT_GLOSSAR, {}, {},
            (res: any) => {
                if (Array.isArray(res[IDs.ENT_GLOSSAR])) {
                    let data = res[IDs.ENT_GLOSSAR] || [];
                    if (!this.props.admin && this.props.data) {
                        this.dataService.loadData(
                            IDs.ENT_GLOSSAR_ZUORDNUNG, {}, {},
                            (obj: any, entity: string) => {
                                const bereich_key: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig
                                    || null;
                                const whitelist: any[] = [];
                                const regulated: any = {};
                                ((obj || {})[entity] || []).forEach((item: any) => {
                                    if ((item.bereich_key_orig || item.bereich_key) === bereich_key && item.glossar) {
                                        whitelist.push(item.glossar_orig || item.glossar);
                                    }
                                    regulated[item.glossar_orig || item.glossar] = true;

                                });
                                // console.log('Glossar', data, whitelist, regulated, obj);
                                data = data.filter((item: any) => !regulated[item.tid] || whitelist.indexOf(item.tid) !== -1);
                                this.setState({ data: this.processData(data), ...tabIndex });
                            },
                            IDs.MOD_ETOOL_ADMIN
                        );
                    } else {
                        this.setState({ data: this.processData(data), ...tabIndex });
                    }
                }
            },
            IDs.MOD_ETOOL_ADMIN
        );
    }

    processData(data: any[]): any[] {
        data = (data || []).filter((item: any) => this.props.admin
            || (item[this.fieldKeys[0].locale] !== null && item[this.fieldKeys[2].locale] !== null));
        const names: any = this.getNames(data);

        data.forEach((row: any) => {
            const keyBeschreibung: string = getFieldKey(row, this.fieldKeys[2]);
            const keyInfo: string = getFieldKey(row, this.fieldKeys[1]);
            const keyName: string = getFieldKey(row, this.fieldKeys[0]);
            row.beschreibung = typeof row[keyBeschreibung] === 'string' ? row[keyBeschreibung] : '';
            const name: string = (names[row[keyName]] || []).length > 1
                ? `${row[keyName]} (${names[row[keyName]].indexOf(row.tid) + 1})`
                : row[keyName];
            const p = parse(row.beschreibung);
            row.beschreibung_parse = p;
            row.beschreibung_table = <div style={{ padding: 3 }}>{p}</div>;
            row.name_table = (
                <div style={{ padding: 3 }}>
                    <div style={{ color: 'rgb(102, 146, 194)', fontWeight: 'bold' }}>
                        <big>{name}</big>
                    </div>
                    {row.info &&
                        <div style={{ color: 'rgb(102, 146, 194)' }}>
                            [{row[keyInfo]}]
                        </div>
                    }
                </div>
            );
            row.info = `${name} ${row[keyInfo]}`;
        });

        return data;
    }

    render(): JSX.Element {
        const mapAZ: any = {};

        (this.state.data || []).forEach((i: any) => {
            let c = i.name.toUpperCase().substring(0, 1);
            if (c === 'Ä') {
                c = 'A';
            } else if (c === 'Ü') {
                c = 'U';
            } else if (c === 'Ö') {
                c = 'O';
            }
            mapAZ[c] = 1;
        });
        const A_Z = Object.keys(mapAZ).sort();
        // const A_Z = Array.from('ABCDEFGHIJKLMNOPQRSTUVWXYZ');

        return <>
            {this.state.data !== null && !(this.state.data || []).length &&
                <div style={{ padding: 10 }}>{i18n('keine Einträge', 'sys')}</div>
            }
            <Tabs
                key={`glossar-${this.state.locale}`}
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                onSelect={(tabIndex, lastIndex, event) =>
                    this.setState({ tabIndex }, () => this.contextService.set('tabIdxMehrsprachigkeitGlossar', this.state.tabIndex))
                }
                selectedIndex={this.state.tabIndex}
            >
                <TabList>
                    {A_Z.map((A: string, i: number) =>
                        <Tab key={`tab_${A}`} style={this.getTabStyle(i)}>{A}</Tab>
                    )}
                </TabList>
                {A_Z.map((A: string, idx: number) =>
                    <TabPanel
                        style={{
                            flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto',
                            flex: this.state.tabIndex === idx ? 1 : 0
                        }}
                        key={`tabPanel_${A}`}>
                        <div style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                            {/*<div
                                style={{
                                    border: '1px solid black', fontWeight: 'bold', padding: 5, backgroundColor: 'rgb(188, 202, 227)',
                                    margin: '10px 5px'
                                }}
                            >{A}</div>Möchte der Kunde doch erstmal nicht*/}
                            <div>{this.renderTable(A)}</div>
                        </div>
                    </TabPanel>
                )}
            </Tabs>
            {this.renderGlossar()}
        </>;
    }

    renderTable(A: string): JSX.Element {
        const isAdmin = this.props.admin;
        // Filtern
        const data = this.state.data.filter((i: any) => {
            let c = i.name.toUpperCase().substring(0, 1);
            if (c === 'Ä') {
                c = 'A';
            } else if (c === 'Ü') {
                c = 'U';
            } else if (c === 'Ö') {
                c = 'O';
            }
            return c === A;
        }).sort((a: any, b: any) => {
            if (a.name > b.name) {
                return 1;
            } else if (a.name < b.name) {
                return -1;
            }
            return 0;
        });

        return (
            <WFormsTableWrapper
                entity={IDs.ENT_GLOSSAR}
                data={data}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={isAdmin ? ['add', 'edit', 'delete'] : []}
                customColumns={this.getCustomColumns()}
                // customActions={this.getCustomActions()}
                hiddenColumns={['name', 'info', 'beschreibung']}
                columnWidths={[300]}
                customClass='Custom-ETA'
                formLayout='flowV2'
                customFormConfigFunc={this.getCustomFormConfigFunc}
                customCssStyle={{
                    formDialogWrapper: { width: 950 },
                    // formFieldRichText: { height: 350 },
                    // outerStyle: { minWidth: 950 }
                }}
                extraFormElementBefore={this.props.isMultilingual ? this.getExtraFormElements() : null}
                onAfterAction={(action: string) => {
                    if (action === 'saveDone' || action === 'delDone') {
                        this.loadData();
                    }
                }}
                // defaultSorted={[{ id: 'name', asc: true }]}
                hideExport
                tablePageSize={5}
                tableFixedHeader
                tableShowPagination={false}
                hideFilterReset
                showTableHelp={false}
            />
        );
    }

    renderGlossar(): JSX.Element {
        const glossar: any = this.state.glossar || {};

        if (!Object.keys(glossar).length) {
            return null;
        }

        return (
            <DialogWrapper2
                width={900}
                height={600}
                title={glossar.name}
                onAfterClose={() => this.setState({ glossar: null })}
            >
                <div style={{ padding: '20px 50px 20px 50px' }}>
                    {glossar.beschreibung_parse}
                </div>
            </DialogWrapper2>
        );
    }
}
